customElements.component = 'color-swatches';

if (!customElements.get(customElements.component)) {
  class ColorSwatches extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        colorSwatchHoverHandler: '.js-toggle-swatch-item-hover',
        dropdown: '.product__colorPickerDropdown',
        dropdownTitle: '.product__colorPickerTitle--title',
        dropdownContent: '.product__colorPickerDropdown',
        productWrapperOverlay: '.product__wrapper--overlay',
        body: 'body',
        wrapper: '.wrapper',

        dropdownActive: 'product__colorPickerDropdown--active',
        productPickerActive: 'product__colorPicker--active',
        productWrapperOverlayActive: 'product__wrapper--overlay-active',
        bodyOverflow: 'body--overflow',
        productColorPickerTitleActive: 'product__colorPickerTitle--active',
        productOverlayTransparent: 'product__wrapper--overlay-transparent',
      };

      this.tag = this.dataset.styleTag;
      this.type = this.dataset.type;
      this.collectionHandle = this.dataset.collectionHandle;
      this.layoutType = this.dataset.isWide === 'true' ? 'wide' : 'regular';
    }

    async fetchDropdownContent() {
      try {
        if (this.collectionHandle && this.tag) {
          const response = await fetch(`${this.collectionHandle}/${encodeURI(this.tag).replace(/%20/g, ':')}?section_id=color-swatch-content-component`);
          const responseLayout = new DOMParser().parseFromString(await response.text(), 'text/html');
          const dropdownResponseContent = responseLayout.querySelector(`.product__colorPickerList[data-layout="${this.layoutType}"]`);
          const dropdownContent = this.querySelector(this.selectors.dropdownContent);

          dropdownContent.insertAdjacentHTML('beforeend', dropdownResponseContent.innerHTML);
          this.classList.add(this.selectors.productPickerActive);
        }
      } catch (error) {
        console.error('Error fetching dropdown content:', error);
        this.remove();
      }
    }

    toggleDropdown(event) {
      const dropdown = event.currentTarget.querySelector(this.selectors.dropdown);
      const overlay = document.querySelector(this.selectors.productWrapperOverlay);

      dropdown.classList.toggle(this.selectors.dropdownActive);
      overlay?.classList.toggle(this.selectors.productWrapperOverlayActive);
      overlay?.classList.toggle(this.selectors.productOverlayTransparent);

      if (window.innerWidth <= 768) {
        const body = document.querySelector(this.selectors.body);

        body.classList.toggle(this.selectors.bodyOverflow);
      }
    }

    toggleHoverColor(event) {
      const currentColor = event.currentTarget.title;
      const currentTitle = this.querySelector(this.selectors.dropdownTitle);
      const colorPickerTitle = this.querySelector(this.selectors.dropdownTitle);
      const startColor = this.querySelector(this.selectors.dropdownTitle).dataset.colorTitle;

      if (event.type == 'mouseover') {
        currentTitle.innerText = currentColor;

        if (!colorPickerTitle.classList.contains(this.selectors.productColorPickerTitleActive)) {
          colorPickerTitle.classList.add(this.selectors.productColorPickerTitleActive);
        } else {
          colorPickerTitle.classList.remove(this.selectors.productColorPickerTitleActive);
          colorPickerTitle.classList.add(this.selectors.productColorPickerTitleActive);
        }
      } else {
        currentTitle.innerText = startColor ? startColor : '';

        colorPickerTitle.classList.contains(this.selectors.productColorPickerTitleActive)
          ? colorPickerTitle.classList.remove(this.selectors.productColorPickerTitleActive)
          : null;
      }
    }

    addEventListeners() {
      const colorSwatchHoverHandlers = this.querySelectorAll(this.selectors.colorSwatchHoverHandler);

      colorSwatchHoverHandlers.forEach(handler => {
        handler.addEventListener('mouseover', this.toggleHoverColor.bind(this));
      });

      colorSwatchHoverHandlers.forEach(handler => {
        handler.addEventListener('mouseout', this.toggleHoverColor.bind(this));
      });

      this.addEventListener('click', this.toggleDropdown.bind(this));
    }

    removeEventListeners() {
      this.removeEventListener('click', this.toggleDropdown.bind(this));
    }

    async connectedCallback() {
      await this.fetchDropdownContent();
      this.addEventListeners();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }
  }

  customElements.define(customElements.component, ColorSwatches);
}
